'use strict';

export default function f($window, $timeout, $location, $uiViewScroll, $state) {
  'ngInject';

  // cache scroll position of each route's templateUrl
  var scrollPosCache = {};

  // compile function
  var directive = function(scope) {

    scope.$on('$stateChangeStart', function(_, toState, toParams, fromState) {
      // store scroll position for the current view
      if ($state.$current) {
        scrollPosCache[fromState.name] = [$window.pageXOffset, $window.pageYOffset];
      }
    });

    scope.$on('$stateChangeSuccess', function(_, toState) {
      var prevScrollPos = scrollPosCache[toState.name] || [0, 0];
      $timeout(function() {
        $window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
      }, 0);
    });
  };

  return directive;
}



// WEBPACK FOOTER //
// ./app/src/directives/keep_scroll_pos.js